var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMockBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 12,
    viewBox: "0 0 25 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80725 3.07696C1.80725 2.39723 2.34667 1.84619 3.01207 1.84619H19.5783C20.2437 1.84619 20.7832 2.39723 20.7832 3.07696V8.92311C20.7832 9.60285 20.2437 10.1539 19.5783 10.1539H3.01207C2.34667 10.1539 1.80725 9.60285 1.80725 8.92311V3.07696Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.01205 0.923077H19.5783C20.7428 0.923077 21.6867 1.88739 21.6867 3.07692V8.92308C21.6867 10.1126 20.7428 11.0769 19.5783 11.0769H3.01205C1.84759 11.0769 0.903614 10.1126 0.903614 8.92308V3.07692C0.903614 1.88739 1.84759 0.923077 3.01205 0.923077ZM0 3.07692C0 1.37759 1.34854 0 3.01205 0H19.5783C21.2418 0 22.5904 1.37759 22.5904 3.07692V8.92308C22.5904 10.6224 21.2418 12 19.5783 12H3.01205C1.34854 12 0 10.6224 0 8.92308V3.07692ZM25 6C25 6.94572 24.3574 7.73812 23.494 7.94648V4.05352C24.3574 4.26188 25 5.05428 25 6Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockBattery);
export default __webpack_public_path__ + "static/media/mock_battery.8295adee3a9fcb3f4fc2a56b0afc2a08.svg";
export { ForwardRef as ReactComponent };